// extracted by mini-css-extract-plugin
export default {"heroBanner":"heroBanner_heroBanner__HKgkW"};